export const MapSourceSystemCode = (code) => {
    var name = "TAL"; //default to TAL
    if (code !== undefined && code.length > 0) {
        if (code.toUpperCase() === "PAS" || code.toUpperCase() === "LEO") {
            name = "TAL"
        }
        else if (code.toUpperCase() === "LFH") {
            name = "ASTERON"
        }
        else if (code.toUpperCase() === "CLO") {
            name = "TLIS"
        }
    }
    return name;
}

export * from './MapSourceSystemCode';